var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "lineup__productLi" }, [
    _c(
      "a",
      {
        attrs: {
          "data-remodal-target": "modal-lineup-" + _vm.item.id,
          href: "#modal-lineup-" + _vm.item.id,
        },
      },
      [
        _c("dl", [
          _c("dt", { class: _vm.icon }, [
            _c("img", {
              staticClass: "js-lineup__random--12",
              attrs: { src: _vm.item.img.model, alt: _vm.item.num },
            }),
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "lineup__productPhoto" }, [
              _c("img", {
                staticClass: "js-lineup__random--12",
                style: { "animation-duration": _vm.rndanim },
                attrs: { src: _vm.item.img.main, alt: "" },
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "js-lineup__random--12b",
                style: { "animation-duration": _vm.rndanim },
                attrs: { src: _vm.item.img.sub, alt: "" },
              }),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }